import STRINGS from "../globals/strings.jsx"
import IMAGES from "../globals/images.jsx"

function noYetData() {
    return (
        <div>
            <div style={{display: "flex", justifyContent: "center", paddingTop: "200px", paddingBottom: "200px"}}>
                <img   src={IMAGES.NOYETDATA} alt={STRINGS.NO_DATA_FOUND} />
            </div>
        </div>
    )
}

export default noYetData